module.exports = __webpack_public_path__ + "img/pontos.b790892e.svg";